// extracted by mini-css-extract-plugin
module.exports = {"customClass":"_widgetGalleryModal_customClass_3d1FN"};